
import { Vue, Component, Prop, Inject } from 'vue-property-decorator'

import { Field as FieldInterface } from '@/interfaces/Field'

@Component
export default class Field extends Vue {

  @Prop() field
  @Prop() section
  @Inject('$validator') $validator

  get fieldPlaceholder() {
    return this.$t('global.field.empty')
  }

  get currentValue() {
    return this.field.value
  }

  updateField(field, val) {

    const emitter: FieldInterface = {
      id: field.id,
      name: field.name,
    }

    const _val = (field.type === 'boolean') ? JSON.parse(val) : val // tslint:disable-line

    field.value = _val
    emitter.value = val

    field.edited = true

    // emit input to simulate v-model
    this.$emit('input', emitter)
  }
}
